import { startOfMonth, subMonths } from 'date-fns';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { constants, isEqualNullableDate } from '../../../helpers';
import {
  changeMastersImportFilterEndImportDate,
  changeMastersImportFilterStartImportDate,
  filterParametersDataSelector,
  reportMastersImportFilterEndImportDateSelector,
  reportMastersImportFilterStartImportDateSelector,
} from '../../../state';
import DateRangeFlexSales, {
  DateRangeFlexSalesProps,
  DateRangeFlexSalesValue,
} from '../../DateRangeFlexSales';

type BusinessDateRangeFilterProps = Pick<DateRangeFlexSalesProps<Date>, 'spacing'>;

const ImportDateRangeFilter = (props: BusinessDateRangeFilterProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const startDate = useSelector(reportMastersImportFilterStartImportDateSelector);
  const endDate = useSelector(reportMastersImportFilterEndImportDateSelector);
  const filterParameters = useSelector(filterParametersDataSelector);
  const minDate = startOfMonth(subMonths(new Date(), filterParameters?.filtersLimitMonths || 3));

  const dateValue: DateRangeFlexSalesValue<Date> = useMemo(
    () => [startDate.raw, endDate.raw] as DateRangeFlexSalesValue<Date>,
    [startDate.raw, endDate.raw]
  );

  const handleChange = useCallback(
    ([newStartDate, newEndDate]: DateRangeFlexSalesValue<Date>) => {
      if (!isEqualNullableDate(newStartDate, startDate.raw as Date)) {
        dispatch(changeMastersImportFilterStartImportDate(newStartDate));
      } else if (!isEqualNullableDate(newEndDate, endDate.raw as Date))
        dispatch(changeMastersImportFilterEndImportDate(newEndDate));
    },
    [dispatch, endDate, startDate]
  );

  return (
    <DateRangeFlexSales
      {...props}
      maxDate={constants.masterImportRangeMaxDate}
      minDate={minDate}
      startText={t('toolbar.labels.fromDateImport')}
      endText={t('toolbar.labels.toDateImport')}
      value={dateValue}
      onChange={handleChange}
    />
  );
};

export default ImportDateRangeFilter;
